import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.match";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listConfig, updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
export default {
  name: "",
  props: ["deviceSn", "deviceDid"],
  data: function data() {
    var checkIP = function checkIP(rule, value, callback) {
      if (value.length == 0) {
        callback(new Error('请输入检测地址'));
      } else {
        for (var i = 0; i < value.length; i++) {
          if (!value[i].match(/^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$|^:((:[\da-fA-F]{1,4}){1,6}|:)$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?$|^([\da-fA-F]{1,4}:){6}:$/)) {
            callback(new Error('请输入正确的IP地址'));
            break;
          }
        }

        callback();
      }
    };

    return {
      networkFormObj: {
        enabled: false,
        mode: "ping",
        pinghosts: [],
        pingperiod: 60,
        period: "10m"
      },
      loading: true,
      rules: {
        pingperiod: [{
          required: true,
          message: "请输入检测周期",
          trigger: "blur"
        }, {
          pattern: /^[1-9]\d*$/,
          message: "请输入正整数",
          trigger: "blur"
        }],
        pinghosts: [{
          validator: checkIP,
          message: "请输入正确的检测地址",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    addPingHost: function addPingHost() {
      this.networkFormObj.pinghosts.push("");
    },
    delPingHost: function delPingHost(index) {
      this.networkFormObj.pinghosts.splice(index, 1);
    },
    getConfig: function getConfig() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        listConfig(_this.deviceSn, _this.deviceDid, [{
          section: "watchcat",
          config: "system",
          options: [{
            option: "enabled"
          }, {
            option: "mode"
          }, {
            option: "pingperiod"
          }, {
            option: "period"
          }, {
            option: "pinghosts"
          }],
          lists: [{
            list: "pinghosts"
          }]
        }]).then(function (res) {
          if (res.data.code == 0) {
            _this.networkFormObj = res.data.data.mess[0].s_objects[0].options;

            if (res.data.data.mess[0].s_objects[0].options.pinghosts) {
              res.data.data.mess[0].s_objects[0].lists.pinghosts.push(res.data.data.mess[0].s_objects[0].options.pinghosts);
            }

            _this.$set(_this.networkFormObj, "pinghosts", res.data.data.mess[0].s_objects[0].lists.pinghosts.length == 0 ? [""] : res.data.data.mess[0].s_objects[0].lists.pinghosts);

            _this.networkFormObj.enabled = _this.networkFormObj.enabled == "1" ? true : false;
          } else {
            _this.$message.error(_this.$t("lang.networkMonitoring.msg1"));
          }

          resolve();
        });
      });
    },
    saveNetwork: function saveNetwork() {
      var _this2 = this;

      this.$refs.network.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          updateConfig(_this2.deviceSn, _this2.deviceDid, [{
            section: "watchcat",
            config: "system",
            action: 0,
            index: [0],
            options: {
              enabled: _this2.networkFormObj.enabled ? "1" : "0",
              mode: _this2.networkFormObj.mode,
              pingperiod: _this2.networkFormObj.pingperiod,
              period: _this2.networkFormObj.period
            },
            lists: {
              pinghosts: _this2.networkFormObj.pinghosts
            }
          }]).then( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(res.data.code == 0)) {
                        _context.next = 6;
                        break;
                      }

                      _this2.$message.success(_this2.$t("lang.networkMonitoring.msg2"));

                      _context.next = 4;
                      return progressControl([{
                        process: 'watchcat',
                        type: 0,
                        action: 'restart'
                      }], _this2.deviceDid, _this2.deviceSn);

                    case 4:
                      _context.next = 7;
                      break;

                    case 6:
                      _this2.$message.error(_this2.$t("lang.networkMonitoring.msg3"));

                    case 7:
                      _this2.loading = false;

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        } else {
          _this2.$message.error(_this2.$t("lang.networkMonitoring.msg4"));

          return false;
        }
      });
    },
    refresh: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getConfig();

              case 2:
                this.loading = false;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.deviceSn && this.deviceDid)) {
                _context3.next = 6;
                break;
              }

              _context3.next = 3;
              return this.getConfig();

            case 3:
              this.loading = false;
              _context3.next = 7;
              break;

            case 6:
              this.$message.error(this.$t("lang.taskDialog.please"));

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }()
};